import { ReactNode } from 'react';
import { Text, Separator, Heading, HeadingProps, Box, Flex } from '@chakra-ui/react';
import QuoteIcon from 'src/assets/icons/QuoteIcon';
import TrustpilotStarsIcon from 'src/assets/icons/TrustpilotStarsIcon';
import { Avatar } from 'src/components/ui/avatar';

interface ReviewProps {
  image?: string;
  name: string;
  title: string;
  children: ReactNode;
}

function AuthorHeading(props: HeadingProps) {
  return <Heading fontSize="14px" color="podcastShade800" my="0" {...props} />;
}

function ReviewHeading(props: HeadingProps) {
  return <Heading fontSize="16px" color="podcastShade700" mt="14px" mb="10px" {...props} />;
}

export default function Review({ image, name, title, children }: ReviewProps) {
  return (
    <>
      <Flex mb="15px">
        <Avatar name={name} src={image} w="42px" h="42px" />
        <Box flexGrow={2} mx="12px">
          <AuthorHeading fontSize="14px">{name}</AuthorHeading>
          <TrustpilotStarsIcon w="96px" h="18px" />
        </Box>
        <QuoteIcon w="37px" h="28px" />
      </Flex>
      <Separator />
      <ReviewHeading>{title}</ReviewHeading>
      <Text visual="lighter" fontSize="14px">
        {children}
      </Text>
    </>
  );
}
